import Icon from "@components/_Revamp/Icon/Icon";
import React from "react";
import { styled } from "@linaria/react";
import { ROUTE_PATH } from "@static/route-paths";
import { Link, useLocation } from "react-router-dom";
import { CONTAINER_SIZE, SCREEN_SIZE } from "@static/screen-size";
import Stepper from "../Stepper";
import { STEPS_LIST } from "@static/content";
import ProductOverviewMobile from "../ProductOverviewMobile";

export default function MainContainer({
  backButtonPath,
  children,
  step,
  backButtonFunction,
}: React.PropsWithChildren<IContainerWithBackButton>) {

  const location = useLocation()
  const currentPath: string | any = location.pathname
  const pathsNotToShowProductOverview = [ ROUTE_PATH.SHIELD_STARTER_GET_QUOTE,
    ROUTE_PATH.SHIELD_STARTER_CHOOSE_PLAN,ROUTE_PATH.SHIELD_STARTER_GET_QUOTE+'/',
    ROUTE_PATH.SHIELD_STARTER_CHOOSE_PLAN,ROUTE_PATH.SHIELD_STARTER_CONTACT_US,
    ROUTE_PATH.SHIELD_STARTER_COFIRMATION, ROUTE_PATH.SHIELD_STARTER_GENERIC_ERROR, ROUTE_PATH.SHIELD_STARTER_CONNECTION_ERROR]
  const currentPathTrimmed = currentPath?.endsWith("/")?currentPath?.slice(0,-1):currentPath || "";
  const enableProductOverView = !(pathsNotToShowProductOverview.includes(currentPathTrimmed))
  
  const stepIndex = step && step > 0 && step <= STEPS_LIST.length  ? step - 1 : 0;
  return (
    <>
      <Container
        noStepper={step ? false : true}
        showProductView={enableProductOverView}
      >
        {(backButtonPath || backButtonFunction) && (
          <BackButton>
            {backButtonPath && (
              <Link
                to={backButtonPath}
                style={{ color: "#000000", fontWeight: 600, fontSize: "16px" }}
              >
                <Icon name="back-arrow"></Icon> Back
              </Link>
            )}
            {backButtonFunction && (
              <span
                onClick={backButtonFunction}
                style={{
                  color: "#000000",
                  fontWeight: 600,
                  cursor: "pointer",
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "10px",
                  fontSize: "16px",
                }}
              >
                <Icon name="back-arrow"></Icon> Back
              </span>
            )}
          </BackButton>
        )}
        {children}
      </Container>
      {enableProductOverView && <ProductOverviewMobile />}
      {step && (
        <Stepper
          steps={STEPS_LIST}
          activeId={STEPS_LIST[stepIndex].id}
        ></Stepper>
      )}
    </>
  );
}

interface IContainerWithBackButton {
  backButtonFunction?: React.MouseEventHandler | null;
  backButtonPath?: string;
  step?: number;
}

const BackButton = styled.div`
  margin-bottom: 24px;
  a {
    text-decoration: none;
    display: flex;
    align-items: center;
    gap: 10px;
    width: fit-content;
  }
  @media (min-width: ${SCREEN_SIZE.mobileSteper}px) {
    margin-bottom: 64px;
  }
`;

const Container = styled.div<{noStepper?: boolean, showProductView?: boolean}>`
  position: relative;
  margin: 0 auto;
  display: block;
  flex-wrap: wrap;
  margin-top: ${({noStepper})=> noStepper ? "0" : "98px"};
  padding: 24px;
  color: #434343;
  margin-bottom: ${({showProductView})=> showProductView ? "125px" : "0"};
  @media (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    max-width: ${CONTAINER_SIZE.desktops}px;
    margin-top: ${({noStepper})=> noStepper ? "24px" : "124PX"};
    margin-bottom: 0;
  }
  
  @media (min-width: ${SCREEN_SIZE.mobileSteper}px) {
    margin-top: 64px;
  }
`;
